import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MDBDatePickerComponent, ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { MaquinaService } from '../../../../services/maquina.service';

@Component({
  selector: 'app-maquinas-maestro-modal-dar-de-baja',
  templateUrl: './modal-dar-de-baja.component.html',
  styleUrls: ['../maquinas-maestro.component.scss'],
  providers: [SecurityService]
})
export class MaquinasMaestroModalDarDeBajaComponent implements OnInit {

  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>()
  @Output() onEnableButtons: EventEmitter<void> = new EventEmitter<void>()

  @ViewChild('darDeBaja', { static: true }) darDeBajaModal: ModalDirective;
  @ViewChild('dtFechaBaja', { static: true }) dtFechaBaja: MDBDatePickerComponent
  formBaja: FormGroup;

  // Data & Tmp
  public rutEmpresa: number
  public sucursalCodigo: number
  public rutUsuario: number
  public numeroPlaca: any
  loading: boolean = false


  optionsTipoDoc: Array<any> = [];
  optionsProveedor: Array<any> = [];

  // Utils
  private log: any
  showProveedor: boolean = false; // MOSTRAR/OCULTAR SELECT PROVEEDOR
  rutNestle: number = 90703000; //RUT NESTLE PROVEEDOR
  tipoDestinatarioCodigo: number

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private datesService: DatesService,
    private tipoDTEService: TipoDTEService,
    private maquinaService: MaquinaService,
    private clienteProveedorService: ClienteProveedorService,
    private rutService: RutService,


  ) {
    this.log = this.clog.log('MAQUINAS BAJA')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
    this.loadProveedores()
    this.loadTiposDte()
    this.createForms()
    this.formChangesSubscriptions();
  }

  formChangesSubscriptions() {
    this.formBaja.get('generar_guia').valueChanges.subscribe((generaGuia: boolean) => {
      if (generaGuia === true && this.formBaja.get('tipoDte').value === 52) {
        this.formBaja.get('descripcion').setValidators([Validators.required]);
      } else {
        this.formBaja.get('descripcion').setValidators([]);
      }
      this.formBaja.get('descripcion').updateValueAndValidity();
    });

    this.formBaja.get('tipoDte').valueChanges.subscribe((tipoDTE: number) => {
      if (tipoDTE === 52 && this.formBaja.get('generar_guia').value === true) {
        this.formBaja.get('descripcion').setValidators([Validators.required]);
      } else {
        this.formBaja.get('descripcion').setValidators([]);
      }
      this.formBaja.get('descripcion').updateValueAndValidity();
    });
  }
  loadTiposDte() {
    this.tipoDTEService.obtenerTipoCompra(({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros } = respuesta
      this.optionsTipoDoc = registros.map(p => ({ value: p.codigo, label: p.nombre, ...p }))
    })
  }

  loadProveedores() {
    const inputParams = {
      filtro: {
        exacto: { empresa_rut: this.rutEmpresa }
      }
    }
    this.clienteProveedorService.obtenerProveedores(inputParams, ({ mensajes, respuesta }) => {

      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros } = respuesta
      this.optionsProveedor = registros.map(p => ({ value: p.rut, label: p.nombre, ...p }))
    })
  }

  private createForms() {
    this.formBaja = this.fb.group({
      tipoDte: [null, [Validators.required]],
      proveedor: [null, []],
      nroDoc: [null, []],
      fechaBaja: [null, [Validators.required]],
      observacion: [null, [Validators.required]],
      descripcion: [null, []],
      generar_guia: [null, []]
    });
  }

  show(mov) {


    this.numeroPlaca = mov.numero_placa
    this.resetAndSetDefaults()
    this.darDeBajaModal.show()

    // * Mostrar proveedores cuando este ubicado en Centro Distribucion/
    this.tipoDestinatarioCodigo = mov.tipo_destinatario_codigo
    this.formBaja.get('generar_guia').setValue(false)
    this.formBaja.get('proveedor').setValue(mov.proveedor_rut)  // POR DEFECTO QUEDA EN NESTLE EN EL SELECT
    if (mov.tipo_destinatario_codigo === 1) {

      //* Condicion que indica si el parametro proveedor es obligatorio o no para inactivar la maquina/
      this.formBaja.get('proveedor').setValidators([Validators.required])

      this.showProveedor = true;
      this.formBaja.get('tipoDte').setValue(52)    // POR DEFECTO QUEDA EN GUIA DE DESPACHO
    }
    if (mov.tipo_destinatario_codigo != 1) {
      this.formBaja.get('proveedor').setValidators([])
      this.showProveedor = false;
      this.formBaja.get('tipoDte').setValue(52)    // POR DEFECTO QUEDA EN GUIA DE DESPACHO
    }

  }

  resetAndSetDefaults() {
    //this.dtFechaBaja.clearDate()
    this.formValidatorsService.reset(this.formBaja)

    // set defaults
    const now = this.datesService.CurrentDateToShortTimeString()
    this.formBaja.get('fechaBaja').setValue(now)
  }

  guardar() {

    const valid = this.formValidatorsService.validate(this.formBaja)
    if (!valid)
      return

    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        numero_placa: this.numeroPlaca,
        tipo_dte_codigo: this.formBaja.get('tipoDte').value,
        numero_documento: this.formBaja.get('nroDoc').value,
        observacion: this.formBaja.get('observacion').value,
        fecha_baja: this.formBaja.get('fechaBaja').value,
        proveedor_rut: this.formBaja.get('proveedor').value,
        tipo_destinatario_codigo: this.tipoDestinatarioCodigo,
        descripcion_glosa: this.formBaja.get('descripcion').value,
        generar_guia: this.formBaja.get('generar_guia').value,
        rut_usuario: this.rutUsuario
      }
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.maquinaService.dardeBajaMaquina(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.loading = false

      this.onSuccess.emit()
      this.darDeBajaModal.hide()
      let tipoDestinatariosPermitidos: number[] = [1, 2, 99];
      if (tipoDestinatariosPermitidos.includes(respuesta.tipo_destinatario_codigo) && respuesta.tipo_dte_codigo === 52) {
        this.toastService.success('Se generó guía despacho Nro.' + respuesta.numero_documento);
      } else {
        this.toastService.success('Operación exitosa')
      }
      this.tipoDestinatarioCodigo = 0

    })
    // this.onSuccess.emit()
    // this.darDeBajaModal.hide()
    // this.toastService.success('Operación exitosa')

  }

  CloseInactivar() {
    this.darDeBajaModal.hide();
    this.onEnableButtons.emit();
  }

}
